export const LeftRightHalf = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.996094"
        y="0.5"
        width="18.2939"
        height="18.2939"
        rx="3.5"
        stroke="black"
      />
      <line
        x1="9.79199"
        y1="19.2939"
        x2="9.79199"
        y2="-1.88549e-06"
        stroke="black"
      />
      <line x1="19.79" y1="10.2954" x2="10.2915" y2="10.2954" stroke="black" />
    </svg>
  );
};
